module.exports = __webpack_public_path__ + "static/img/4104_phase_function_Paper_Points.17bca3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4104_phase_function_Paper_Points.png
// module id = WKAU
// module chunks = 0